import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Button, Grid } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomModal from "../../../../common/custom-modal";
import { Styles } from "./styles";

const ViewServiceModal = ({ open, setOpen, data }) => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate(`/PanelsDetails/${data?.panelUuid}`);
  };

  return (
    <div>
      <CustomModal
        open={open}
        setOpen={setOpen}
        title={"Service Details"}
        description={
          "Here are all the Details you want to know about the service"
        }
        data={
          <Styles>
            <Grid
              container
              style={{ justifyContent: "space-between" }}
              spacing={1}
            >
              <Grid item xs={5}>
                <span className="name">ID</span>{" "}
                <span className="data">{data?.id}</span>
              </Grid>
              <Grid item xs={5}>
                <span className="name">Category</span>{" "}
                <span className="data">{data?.category}</span>
              </Grid>
              <Grid item xs={5}>
                <span className="name">Rate</span>{" "}
                <span className="data">{data?.rate_per_1000}</span>
              </Grid>
              <Grid item xs={5}>
                <span className="name">Min & Max</span>{" "}
                <span className="data">{data?.order_range}</span>
              </Grid>
              <Grid item xs={5}>
                <span className="name">Panel</span>{" "}
                <span className="data">
                  <a
                    onClick={handleNavigation}
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    target="_blank"
                  >
                    {data?.panelUrl}
                  </a>
                </span>
              </Grid>
              <Grid
                item
                xs={5}
                component={Link}
                to={`/ServiceDetails/${data?.id}`}
              >
                <span className="name">Service</span>{" "}
                <span
                  className="data"
                  style={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  {data?.name}
                </span>
              </Grid>
              <Grid item xs={12}>
                <div className="name description">Description</div>
                <div className="data description">{data?.description}</div>
              </Grid>
              <div></div>
              <Grid item xs={12} className="btn-container">
                <Button className="btn" onClick={handleNavigation}>
                  Go To Panel Profile
                  <ArrowForwardIcon />
                </Button>
              </Grid>
            </Grid>
          </Styles>
        }
      />
    </div>
  );
};

export default ViewServiceModal;
